<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup lang="ts">
import { dynamicExtraOptions } from '@/refs/product.refs';
import { formatPrice } from '@/utils/formatPrice';
import { ref } from 'vue';
const props = defineProps([
  'productId',
  'extra',
  'extraMenus',
  'isHiddenProps',
  'titleMenu',
]);
const valueCheckArray = ref<boolean[]>([]);
const enableScroll = () => {
  document.body.style.overflow = '';
};
</script>
<template>
  <div class="scrollbar h-70 w-full overflow-x-hidden">
    <div
      v-for="(item, index) in dynamicExtraOptions"
      :key="index"
      class="flex flex-col gap-0"
    >
      <!-- <div :ref="(el) => setRef(el, index)" class="h-[1px]"></div> -->
      <div class="bg-soft-gray my-[16px] h-1 w-full" />
      <div
        :id="item.designation"
        :class="
          valueCheckArray[index]
            ? 'flex w-full items-center bg-white/10 backdrop-blur-[30px]'
            : 'z-2000 flex w-full items-center bg-white/10 px-0 backdrop-blur-[30px]'
        "
        class="SecondContainer z-30 m-0! flex h-auto! w-full flex-row! items-center! justify-between! px-[16px]! font-medium!"
      >
        <div
          class="gap-8px text-text-primary! flex flex-col items-start leading-[14px] font-medium!"
        >
          <p
            class="text-grand-text text-14px font-tt-semiBold-Normal text-ellipsis"
          >
            {{ item.nameExtra }}
          </p>

          <p
            class="text-secondary-text text-12px font-tt-normal-Normal text-ellipsis"
          >
            {{
              item.conditionExtra === 'unique'
                ? 'Choississez-en 1.'
                : Number(item?.valueQty) > 0
                  ? 'Choisissez' +
                    ' ' +
                    Number(item?.valueQty) +
                    ' ' +
                    'au maximum'
                  : Number(item?.valueQty) > 0
                    ? 'Choisissez' +
                      ' ' +
                      Number(item?.valueQty) +
                      ' ' +
                      'au minimum'
                    : Number(item?.valueQty) > 0
                      ? 'Choisissez' +
                        ' ' +
                        Number(item?.valueQty) +
                        ' ' +
                        'au total'
                      : ''
            }}
          </p>
        </div>

        <div class="flex flex-row items-center gap-1">
          <div class="flex flex-row items-center justify-center">
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.00033 13.3332C10.2087 13.3332 12.8337 10.7082 12.8337 7.49984C12.8337 4.2915 10.2087 1.6665 7.00033 1.6665C3.79199 1.6665 1.16699 4.2915 1.16699 7.49984C1.16699 10.7082 3.79199 13.3332 7.00033 13.3332Z"
                :stroke="item.required ? '#FF2D2D' : '#625353'"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 5.1665V8.08317"
                :stroke="item.required ? '#FF2D2D' : '#625353'"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                :stroke="item.required ? '#FF2D2D' : '#625353'"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <p
            :class="item.required ? 'text-decroissance' : 'text-grand-text'"
            class="text-12px font-tt-normal-Normal transition-all delay-200 duration-300 ease-in-out"
          >
            {{ item.required === true ? ' Obligatoire' : 'Facultatif' }}
          </p>
        </div>
      </div>

      <form class="mx-[16px]! gap-0! rounded-[10px]">
        <div
          class="centerContainerLine"
          v-for="(itemsDetails, index) in item.extraOptions"
          :key="itemsDetails.name + index"
        >
          <div
            v-if="item.conditionExtra === 'unique' ? true : false"
            class="m-0! w-full"
          >
            <div
              class="relative m-0! flex h-[45px] max-w-full flex-row items-center justify-between"
            >
              <p
                class="text-12px text-grand-text font-tt-medium-Normal m-0! leading-normal"
              >
                {{ itemsDetails.name }}
              </p>
              <div class="flex flex-row items-center justify-center gap-2 py-4">
                <p
                  class="text-12px text-grand-text font-tt-medium-Normal m-0! leading-normal"
                  :class="
                    Number(itemsDetails?.price) === 0 ? 'hidden' : 'visible'
                  "
                >
                  {{
                    Number(itemsDetails?.price) === 0
                      ? ''
                      : ' + ' + formatPrice(Number(itemsDetails?.price))
                  }}
                </p>

                <label
                  :id="
                    'labelValue' +
                    itemsDetails.name +
                    'sep' +
                    itemsDetails.price +
                    itemsDetails.name
                  "
                  :for="
                    itemsDetails.name +
                    'sep' +
                    itemsDetails.price +
                    itemsDetails.name
                  "
                  class="inputRadioValue relative flex items-center justify-center"
                >
                  <!-- <span
                    v-show="
                      selectedRadio[item.id] ===
                        JSON.stringify({
                          extraId: item.id,
                          optionId: itemsDetails.id,
                          qty: 1,
                          price: itemsDetails.price,
                        }) && selectedRadio[item.id] !== 'none'
                    "
                    class="size-[5px] rounded-full !bg-white bg-inherit"
                  ></span> -->
                  <div
                    class="invisible absolute top-0 left-0 h-5 w-5 rounded-full bg-white/10"
                    @mousedown.stop
                    @mouseup.stop
                    @touchstart.stop
                    @touchend.stop
                    @wheel.prevent
                    @scroll.prevent
                  ></div>

                  <input
                    type="radio"
                    :name="'group-' + item.designation"
                    :id="
                      itemsDetails.name +
                      'sep' +
                      itemsDetails.price +
                      itemsDetails.name
                    "
                  />
                </label>
              </div>
            </div>

            <div
              class="bg-soft-gray h-px w-full"
              :class="
                index === item.extraOptions?.length - 1 ? 'hidden' : 'block'
              "
            />
          </div>

          <!-- ICI LA SECTION CHECK BOX Y EST GERE -->
          <div v-else class="w-full">
            <label
              :for="itemsDetails.name + itemsDetails.name"
              class="flex! h-[45px]! w-full! flex-row! items-center! justify-between! border-none! transition-none!"
            >
              <p
                class="text-12px! text-text-newUpdateBigTexte! m-0! font-medium!"
              >
                {{ itemsDetails.name }}
              </p>
              <div class="flex flex-row items-center justify-center gap-2 py-4">
                <p
                  class="text-12px! text-text-newUpdateBigTexte my-0! font-medium"
                >
                  {{
                    Number(itemsDetails?.price) === 0
                      ? ''
                      : ' + ' + formatPrice(Number(itemsDetails?.price))
                  }}
                </p>

                <input
                  type="checkbox"
                  name="datachoisse"
                  :id="
                    itemsDetails.name + itemsDetails.price + itemsDetails.name
                  "
                  class="custom-checkbox my-0!"
                />
              </div>
            </label>
            <div
              class="bg-soft-gray h-px w-full"
              :class="
                index === item.extraOptions?.length - 1 ? 'hidden' : 'block'
              "
            />
          </div>

          <button
            type="submit"
            class="!W-[0.1px] bg-background! invisible absolute top-0 m-0! h-[0.1px]! p-0!"
            id="buttonSubimt"
          ></button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.lgShadow {
  filter: drop-shadow(0px 2px 4px rgba(147, 130, 130, 0.1));
}
.inputeTextArea {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  border: 1px solid rgba(147, 130, 130, 0.2);

  border-radius: 10px;
  padding: 12px 16px;
}
.inputeTextArea::placeholder {
  color: rgba(147, 130, 130, 0.2);
}
.inputRadioValue label {
  border: 1px solid rgba(147, 130, 130, 0.2);
  filter: drop-shadow(0px 2px 4px rgba(147, 130, 130, 0.2));
  border-radius: 21px;
  box-sizing: border-box;
}
</style>
